import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { OTRO } from 'src/app/models/constantes';
import { ETipoPreferencia, ETipoProducto } from 'src/app/models/enums.enum';
import { IItem, IPreferencia } from 'src/app/models/interfaces-apis/diccionarios';
import { IFichaCliente, IPreferenciaCliente } from 'src/app/models/interfaces-apis/ficha_cliente';
import { GrupoPreferenciaComponent } from '../../../form-componentes/grupo-preferencia/grupo-preferencia.component';
import { SelectSearchMaterialComponent } from '../../../form-componentes/material-framework/select-search-material/select-search-material.component';
import { preferencias } from 'src/app/models/General/preferencias';
import { ObservacionesComponent } from '../../../form-componentes/observaciones/observaciones.component';
import { UserService } from 'src/app/servicios/user.service';

@Component({
  selector: 'app-preferencia-alojamiento',
  templateUrl: './preferencia-alojamiento.component.html',
  styleUrls: ['./preferencia-alojamiento.component.scss']
})
export class PreferenciaAlojamientoComponent extends preferencias implements OnInit {

  @ViewChild('Grupo_Preferencia_Alojamiento_Cadenas') Grupo_Preferencia_Alojamiento_Cadenas: SelectSearchMaterialComponent;
  @ViewChild('Grupo_Preferencia_Alojamiento_Cadenas_Observacion') Grupo_Preferencia_Alojamiento_Cadenas_Observacion: ObservacionesComponent;
  @ViewChildren('Grupo_Preferencia_Alojamiento') grupos!: QueryList<GrupoPreferenciaComponent>;
  
  constructor(private _userService: UserService) {
    super();
  }

  ngOnInit(): void {
  }

  ETipoProducto = ETipoProducto;
  
  isOtro: boolean = false;
  TipoPreferencia = ETipoPreferencia;

  @Input() preferencias: IPreferencia[];
  @Input() Companias: IItem[];

  @Input() clienteFicha: IFichaCliente;
  @Input() listaOtros: string[];


  //En caso alojamiento tener la opcion de elegir otro
  seleccionarOpcionOtroAlojamiento(opciones) {
    if (opciones.find(a => a.toString() == OTRO)) {
      this.isOtro = true;
    } else {
      this.isOtro = false;
    }
  }

  //Obtener la lista de las preferencias alojamiento guardadas
  obtenerPreferenciasGuardadas(): IPreferenciaCliente[] {

    let ListaPreferencias: IPreferenciaCliente[] = []

    this.grupos.forEach((grupo) => {
      let resultado = grupo.obtenerPreferencias();
      let opcionesPreferencias: IPreferenciaCliente = {
        Tipo: grupo.Id,
        Preferencias: resultado[0],
        InfoEspecifica: resultado[1]
      };
      ListaPreferencias.push(opcionesPreferencias);
    });
    console.log('this._userService.getTipoPreferenciasId')
    console.log(this._userService.getTipoPreferenciasId('CadenasHoteleras'))
    let CadenasAlojamiento: IPreferenciaCliente = {
      Tipo: this._userService.getTipoPreferenciasId('CadenasHoteleras'),
      Preferencias: this.Grupo_Preferencia_Alojamiento_Cadenas.obtenerPreferencias(),
      InfoEspecifica: this.obtenerObservacion()
    }
    ListaPreferencias.push(CadenasAlojamiento)


    return ListaPreferencias;

  }

  //En caso de seleccionar Otro tendremos una opción de observaciones
  obtenerObservacion(): string | null {
    let observacion: string | null = null;
    if (this.texto !== null && this.texto.length > 0) {
      observacion = this.texto;
    }
    return observacion;
  }

  //Actualziar preferencias Alojamiento
  actualizar() {
    let preferencias = this.clienteFicha.Preferencias;
    let preferenciasTipoHotel = this.preferencias.filter(o => o.TipoProducto === ETipoProducto.Hotel);
    let idsPreferencias = preferenciasTipoHotel.map(o => o.Id);
    let resultado = preferencias.filter(o => idsPreferencias.includes(o.Tipo));
    this.grupos.forEach((grupo) => {
      const preferencia = resultado.find(p => p.Tipo === grupo.Id);
      if (preferencia) {
        grupo.actualizar(preferencia.Preferencias, preferencia.InfoEspecifica);
      }
    });

    let preferenciaCadenasHotel: IPreferenciaCliente = this.obtenerPreferenciasCliente(preferencias, this._userService.getTipoPreferenciasId('CadenasHoteleras'))

    if (preferenciaCadenasHotel?.Preferencias.find(a => a.toString() == OTRO)) {
      this.isOtro = true;
      this.Grupo_Preferencia_Alojamiento_Cadenas_Observacion.actualizar(preferenciaCadenasHotel?.InfoEspecifica)
    }

    this.Grupo_Preferencia_Alojamiento_Cadenas.actualizarSeleccion(preferenciaCadenasHotel?.Preferencias);

  }

  //Validar preferencias Alojamiento
  validarPreferencias() {
    let validacionPreferenciasAlojamiento = this.grupos.toArray().every(grupo => grupo.validarPreferencias());
    let estadoCadenasAlojamiento = this.Grupo_Preferencia_Alojamiento_Cadenas.validarPreferencias()
    return validacionPreferenciasAlojamiento && estadoCadenasAlojamiento;
  }



}
